import getAgent from '@egjs/agent';
import { useRef } from 'react';

export enum Device {
  MOBILE = 'MOBILE',
  PC = 'PC',
}

export default function useDevice() {
  const device = useRef<Device>();

  const getDevice = () => {
    if (!device.current) {
      const { isMobile } = getAgent();
      device.current = isMobile ? Device.MOBILE : Device.PC;
    }
    return device.current;
  };

  return getDevice();
}
